/* eslint-disable import/prefer-default-export */
import { EnumSports } from '@types';

export const isFootball = (sport?: EnumSports) =>
	sport === EnumSports.football11 ||
	sport === EnumSports.football5 ||
	sport === EnumSports.babyFootball ||
	sport === EnumSports.football7 ||
	sport === EnumSports.football8;
